import { graphql } from '@graphql/__generated'

export const ELEVATE_ACCOUNT = graphql(`
  mutation elevateAccount($orgName: String!) {
    elevateAccount(orgName: $orgName) {
      success
      orgName
      error
    }
  }
`)
